(() => {
  function hrefForAvailableVariant(productUrl, availableVariants, option1, baseUrl) {
    const url = new URL(productUrl, baseUrl);
    url.searchParams.delete('variant');

    const match = Array.isArray(availableVariants)
      ? availableVariants.find(
          (variant) =>
            variant &&
            String(variant.option1 ?? '') === String(option1 ?? '') &&
            variant.id != null &&
            String(variant.id).trim() !== ''
        )
      : null;
    if (match) url.searchParams.set('variant', String(match.id).split('/').pop());

    return `${url.pathname}${url.search}${url.hash}`;
  }

  function updateLinks(root, option1, baseUrl) {
    root.querySelectorAll('a[data-jax-product-url][data-jax-variants]').forEach((link) => {
      let variants = [];
      try {
        variants = JSON.parse(link.dataset.jaxVariants || '[]');
      } catch (_error) {
        // Invalid data must not leave a stale variant selected.
      }
      link.setAttribute('href', hrefForAvailableVariant(link.dataset.jaxProductUrl, variants, option1, baseUrl));
    });
  }

  function handleVariantChange(event) {
    const data = event?.data;
    if (data?.sectionId == null) return;
    const roots = document.querySelectorAll('[data-jax-model-picker]');
    roots.forEach((root) => {
      if (String(root.dataset.sectionId) === String(data.sectionId)) {
        updateLinks(root, data.variant?.option1 ?? '', window.location.origin);
      }
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { hrefForAvailableVariant };
  }

  if (typeof document !== 'undefined' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, handleVariantChange);
  }
})();
